import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import {
	performGetRequest,
	performPostRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { SettingsV4Get, SettingsV4Set } from './SettingsGet.types.tsx';

export const get = async (): Promise<SettingsV4Get> => {
	try {
		return await performGetRequest('/rest/internal/4/announcement-banner');
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// 403 - banner is set to private and user is anonymous
		if (error.statusCode === 403) {
			return {
				content: '',
				bgColor: 'grey',
				isEnabled: false,
				isDismissable: false,
				visibility: 'private',
				hashId: '',
			};
		}

		fireErrorAnalytics({
			meta: {
				id: 'settingsV4Get',
				packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
				teamName: 'jira-cosmos',
			},
			error,
		});
		throw error;
	}
};

export const set = async (body: SettingsV4Set): Promise<SettingsV4Get> => {
	try {
		return await performPostRequest('/rest/internal/4/announcement-banner', {
			body: JSON.stringify(body),
		});
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'settingsV4Set',
				packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
				teamName: 'jira-cosmos',
			},
			error,
		});
		throw error;
	}
};

export const announcementBannerApiService: {
	get: () => Promise<SettingsV4Get>;
	set: (body: SettingsV4Set) => Promise<SettingsV4Get>;
} = {
	get,
	set,
};
